export default "__VITE_PUBLIC_ASSET__25db0f88__"